const styleMinimalist = [
  {
    featureType: 'all',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f0f0f0'
      }
    ]
  },
  {
    featureType: 'all',
    elementType: 'all',
    stylers: [
      {
        saturation: '-28'
      },
      {
        lightness: '-1'
      }
    ]
  },
  {
    featureType: 'administrative',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#cfcfcf'
      }
    ]
  },
  {
    featureType: 'landscape',
    elementType: 'all',
    stylers: [
      {
        saturation: '35'
      },
      {
        lightness: 37.599999999999994
      },
      {
        gamma: 1
      }
    ]
  },
  {
    featureType: 'landscape',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#f0f0f0'
      }
    ]
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#f0f0f0'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [
      {
        saturation: '-40'
      },
      {
        lightness: '27'
      },
      {
        color: '#dcdcdc'
      }
    ]
  },
  {
    featureType: 'road.highway',
    elementType: 'all',
    stylers: [
      {
        hue: '#dcdcdc'
      },
      {
        saturation: '-100'
      },
      {
        lightness: '44'
      },
      {
        gamma: 1
      }
    ]
  },
  {
    featureType: 'road.arterial',
    elementType: 'all',
    stylers: [
      {
        saturation: -100
      },
      {
        lightness: '48'
      },
      {
        gamma: 1
      }
    ]
  },
  {
    featureType: 'road.local',
    elementType: 'all',
    stylers: [
      {
        hue: '#dcdcdc'
      },
      {
        saturation: -100
      },
      {
        lightness: '43'
      },
      {
        gamma: 1
      }
    ]
  },
  {
    featureType: 'transit.station.airport',
    elementType: 'all',
    stylers: [
      {
        saturation: '11'
      },
      {
        lightness: '40'
      },
      {
        hue: '#dcdcdc'
      }
    ]
  },
  {
    featureType: 'transit.station.rail',
    elementType: 'all',
    stylers: [
      {
        saturation: '-19'
      },
      {
        lightness: '0'
      }
    ]
  },
  {
    featureType: 'water',
    elementType: 'all',
    stylers: [
      {
        saturation: '23'
      },
      {
        lightness: '69'
      },
      {
        gamma: 1
      }
    ]
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#00e1ff'
      }
    ]
  }
];

export default styleMinimalist;
